// extracted by mini-css-extract-plugin
export var card = "_sf-0";
export var details = "_sf-1";